import Vue from 'vue'

const env = {
    DEV: 'development',
    STA: 'staging',
    PRO: 'production',
    DEMO: 'demo',
}

const AuthenticationService = {
    SELF: 'SELF',
    FPT_ID: 'FPT_ID',
}

const CustomerFileUpLoadStatus = {
    PROCESSING: 0,
    COMPLETED: 1,
    ERROR: 2,
}

const ShowTimeRangeTypes = {
    QUICK_OPTION: 'QUICK_OPTION',
    CUSTOM: 'CUSTOM',
}

const MessageTypes = {
    START: 'START',
    GET_MORE_PROMPT: 'GET_MORE_PROMPT',
    END_CALL: 'END_CALL',
}

const HistoryTypes = {
    ALL: 'all',
    CHAT: 'chat',
    CALL: 'call',
}

const HttpMethods = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE']

const HttpMethodsMap = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
}
const ExcelTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel',
    'text/csv'
]
const $const = {
    env,
    DATE_FORMAT: 'YYYY-MM-DD',
    LANGUAGE: 'LANGUAGE',
    campaign: {
        permission: {
            ADMIN: 'admin',
            VIEWER: 'viewer',
            OWNER: 'owner',
            REPORTER: 'reporter',
            OUTBOUND_CALLER: 'outbound_caller',
        },
        status: {
            NOTYET: 'NOTYET',
            RUNNING: 'RUNNING',
            FINISHED: 'FINISHED',
            CANCELED: 'CANCELED',
            INVALID: 'INVALID',
            NA: 'NA',
        },
        statusList: [
            {
                text: 'Running',
                value: 'running'
            },
            {
                text: 'Finished',
                value: 'finished'
            },
            {
                text: 'Waiting',
                value: 'waiting'
            },
            {
                text: 'Pause',
                value: 'pause'
            },
        ],
        actionAuditList: {
            CREATE_PERMISSION: 'CREATE PERMISSION',
            CREATE_CAMPAIGN_SCHEDULE: 'CREATE CAMPAIGN SCHEDULE',
            UPDATE_CAMPAIGN_SCHEDULE: 'UPDATE CAMPAIGN SCHEDULE',
            DELETE_CAMPAIGN_SCHEDULE: 'DELETE CAMPAIGN SCHEDULE',
            CREATE_VOICE_PROFILE: 'CREATE VOICE PROFILE',
            UPDATE_VOICE_PROFILE: 'UPDATE VOICE PROFILE',
            DELETE_VOICE_PROFILE: 'DELETE VOICE PROFILE',
            CREATE_CALL_TREATMENT_CONFIG: 'CREATE CALL TREATMENT CONFIG',
            UPDATE_CALL_TREATMENT_CONFIG: 'UPDATE CALL TREATMENT CONFIG',
            DELETE_CALL_TREATMENT_CONFIG: 'DELETE CALL TREATMENT CONFIG',
            CREATE_AUTO_REPORT_CONFIG: 'CREATE AUTO REPORT CONFIG',
            UPDATE_AUTO_REPORT_CONFIG: 'UPDATE AUTO REPORT CONFIG',
            DELETE_AUTO_REPORT_CONFIG: 'DELETE AUTO REPORT CONFIG',
            CREATE_BLACKLIST_NUMBER: 'CREATE BLACKLIST NUMBER',
            DELETE_BLACKLISTED_NUMBER: 'DELETE BLACKLISTED NUMBER',
            UPDATE_GENERAL_CAMPAIGN_SETTING: 'UPDATE GENERAL CAMPAIGN SETTING',
            UPDATE_CAMPAIGN_CONFIG: 'UPDATE CAMPAIGN CONFIG',
            UPDATE_CAMPAIGN_STATUS: 'UPDATE CAMPAIGN STATUS',
            CREATE_CUSTOMER: 'CREATE CUSTOMER',
            DELETE_A_CUSTOMER: 'DELETE A CUSTOMER',
            DELETE_CUSTOMERS_IN_A_PERIOD: 'DELETE CUSTOMERS IN A PERIOD',
            DELETE_ALL_CUSTOMERS: 'DELETE ALL CUSTOMERS',
            CREATE_CUSTOMER_PROPERTY: 'CREATE CUSTOMER PROPERTY',
            UPDATE_CUSTOMER_PROPERTY: 'UPDATE CUSTOMER PROPERTY',
            DELETE_CUSTOMER_PROPERTY: 'DELETE CUSTOMER PROPERTY',
            CALL_OUT: 'CALL_OUT',
            UPLOAD_CALL_LIST: 'UPLOAD CALL LIST',
            CHECK_USER_CAMPAIGN: 'CHECK USER CAMPAIGN',
        },
    },
    scenario: {
        audioEngine: {
            DURATION: 'duration',
            NOISE_LEVEL: 'noise_level',
            GENDER_DETECTION: 'gender_detection',
        },
        audioEngineList: [
            {
                text: 'Duration',
                value: 'duration'
            },
            {
                text: 'Noise Level',
                value: 'noise_level'
            },
            {
                text: 'Gender Detection',
                value: 'gender_detection'
            }
        ]
    },
    QCCampaign: {
        permission: {
            ADMIN: 'admin',
            QC_LEAD: 'qc_lead',
            QC_MEMBER: 'qc_member',
        },
        permissionList: [
            {
                text: 'Admin',
                value: 'admin'
            },
            {
                text: 'QC Lead',
                value: 'qc_lead'
            },
            {
                text: 'QC Member',
                value: 'qc_member'
            },
        ]
    },
    dateFormat: 'YYYY-MM-DD',
    timeFormat: 'HH:mm',
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    itemPerPage: 15,
    perPageArray: [10, 15, 30, 50, 100],
    sortBy: 'title',
    sortDirection: 'asc',
    RUN_ALL_TESTCASES: 'run-all-testcase',
    authenticationService: AuthenticationService,
    CustomerFileUpLoadStatus,
    ShowTimeRangeTypes,
    MessageTypes,
    HttpMethods,
    HttpMethodsMap,
    ExcelTypes,
    HistoryTypes,
}

Vue.prototype.$const = $const

export default $const
